import axios from "axios";
export default class YoutubeClient {
    constructor() { 
         this.httpClient = axios.create({
            baseURL: 'https://www.googleapis.com/youtube/v3',
            params: { key: process.env.REACT_APP_YOUTUBE_API_KEY },
        })

    }

        async search(params) {
        return this.httpClient.get('search', params);
    }

    async videos(params) {
        return this.httpClient.get('videos', params);
    }

    async channels(params) {
        return this.httpClient.get('channels', params);
    }

    async playlist(params) {
        return this.httpClient.get('playlists', params);
    }
    
    // async channelImageURL(id) {
    //     // 채널에 대한 상세한 정보 가져오기
    //     return this.apiClient
    //         .channels({params: {part: 'snippet', id}})`
    //         .then(res=> res.data.items[0].snippet.thumbnails.default.url); // url을 받아온다. 이미지url을 받아온다.
    // }
}